import { render, staticRenderFns } from "./ClaimNew.vue?vue&type=template&id=5a2a9791&"
import script from "./ClaimNew.vue?vue&type=script&lang=js&"
export * from "./ClaimNew.vue?vue&type=script&lang=js&"
import style0 from "./ClaimNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimNew.vue"
export default component.exports